export { default } from './DashboardGenreChart';
